<app-header extraClass="nav-down text-gray-innerMenu"></app-header>
<section class="notfound-page-wrp">
  <div class="container">
    <div class="notfound-page-card">
      <img src="assets/images/404.png" alt="">
      <p></p>
      <a [routerLink]="['/']" class="btn-default">Back to Home</a>
    </div>
  </div>
</section>
<app-footer></app-footer>
